const API_BASE_URL = 'https://www.iprod.com.ua/userservice/';
const API_BASE_URL_DEV = 'https://www.iprod.com.ua/userservice/';

const PULSE_SERVICE_BASE_URL = 'https://www.iprod.com.ua/pulseservice/';
const PULSE_SERVICE_BASE_URL_DEV = 'http://localhost:5100/';

export default {
  apiBaseUrl: API_BASE_URL,
  apiBaseUrlDev: API_BASE_URL_DEV,
  pulseServiceBaseUrl: PULSE_SERVICE_BASE_URL,
  pulseServiceBaseUrlDev: PULSE_SERVICE_BASE_URL_DEV
};
